// assets/curved-shadows.js
class CurvedShadows {
  constructor(selector) {
    this.selector = selector;
    this.init();
  }
  
  init() {
    const sliderWrapper = document.querySelector(this.selector);
    if (!sliderWrapper) return;
    
    this.sliderWrapper = sliderWrapper;
    this.createCanvases();
    this.updateShadows();
    this.bindEvents();
  }
  
  createCanvases() {
    this.topCanvas = document.createElement('canvas');
    this.bottomCanvas = document.createElement('canvas');
    
    const canvasStyle = {
      position: 'absolute',
      left: '0',
      width: '100%',
      height: '50px',
      pointerEvents: 'none',
      zIndex: '10'
    };
    
    Object.assign(this.topCanvas.style, canvasStyle, { top: '-5px' });
    Object.assign(this.bottomCanvas.style, canvasStyle, { bottom: '-5px' });
    
    this.sliderWrapper.style.position = 'relative';
    this.sliderWrapper.appendChild(this.topCanvas);
    this.sliderWrapper.appendChild(this.bottomCanvas);
  }
  
  drawCurvedShadow(canvas, isTop) {
    const ctx = canvas.getContext('2d');
    const width = this.sliderWrapper.offsetWidth;
    const height = 50;
    
    canvas.width = width;
    canvas.height = height;
    
    ctx.clearRect(0, 0, width, height);
    
    const gradient = ctx.createLinearGradient(
      0, 
      isTop ? 0 : height, 
      0, 
      isTop ? height : 0
    );
    
    gradient.addColorStop(0, 'rgba(255, 255, 255, 0.6)');
    gradient.addColorStop(0.4, 'rgba(255, 255, 255, 0.3)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
    
    ctx.fillStyle = gradient;
    ctx.beginPath();
    
    if (isTop) {
      ctx.moveTo(0, 5);
      ctx.bezierCurveTo(width * 0.25, height * 0.65, width * 0.75, height * 0.65, width, 5);
      ctx.lineTo(width, height);
      ctx.lineTo(0, height);
    } else {
      ctx.moveTo(0, 0);
      ctx.lineTo(width, 0);
      ctx.lineTo(width, height - 5);
      ctx.bezierCurveTo(width * 0.75, height * 0.35, width * 0.25, height * 0.35, 0, height - 5);
    }
    
    ctx.closePath();
    ctx.fill();
  }
  
  updateShadows() {
    this.drawCurvedShadow(this.topCanvas, true);
    this.drawCurvedShadow(this.bottomCanvas, false);
  }
  
  bindEvents() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.updateShadows(), 100);
    });
    
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => this.updateShadows());
    }
  }
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CurvedShadows('.ai-media-slider-wrapper-avkvvl3vhmwrasdvloaigenblock30a539f8ruru3');
  });
} else {
  new CurvedShadows('.ai-media-slider-wrapper-avkvvl3vhmwrasdvloaigenblock30a539f8ruru3');
}